// Animación de hint cuando el usuario ve la primera tarjeta
document.addEventListener('DOMContentLoaded', function() {
  if (sessionStorage.getItem('productCardHintShown')) return;

  const firstCard = document.querySelector('.product-card__carousel');
  if (!firstCard) return;

  const carouselTrack = firstCard.querySelector('.carousel-track');
  if (!carouselTrack) return;

  const slides = carouselTrack.querySelectorAll('.carousel-slide');
  if (slides.length < 2) return;

  let hintTimer = null;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {

      if (entry.isIntersecting) {
        // Iniciar contador de 2 segundos solo cuando es visible
        hintTimer = setTimeout(function() {

          carouselTrack.style.transition = 'transform 1.1s cubic-bezier(0.25, 0.1, 0.25, 1)';
          carouselTrack.style.transform = 'translateX(-8%)';

          setTimeout(function() {
            carouselTrack.style.transition = 'transform 1.1s cubic-bezier(0.25, 0.1, 0.25, 1)';
            carouselTrack.style.transform = 'translateX(0%)';

            setTimeout(function() {
              carouselTrack.style.transition = '';
            }, 1100);
          }, 1100);

          sessionStorage.setItem('productCardHintShown', 'true');
          observer.disconnect();

        }, 2000);

      } else {
        // Si el usuario scrollea y deja de ver la card, cancelar el timer
        if (hintTimer) {
          clearTimeout(hintTimer);
          hintTimer = null;
        }
      }
    });
  }, {
    threshold: 0.8 // 80% de la card debe ser visible
  });

  observer.observe(firstCard);
});
